import React, { useEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

// Lien universel pour les publicités (TikTok, Meta, YouTube) — un seul lien
// à distribuer partout, qui redirige automatiquement selon l'appareil.
const APP_STORE_URL = 'https://apps.apple.com/ca/app/soumissionpro/id6776347147';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=net.soumissionpro.twa';
const WEB_URL = 'https://soumissionpro.net';

function detectOS() {
  if (typeof navigator === 'undefined') return 'other';
  const ua = navigator.userAgent || navigator.vendor || '';
  if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return 'ios';
  if (/android/i.test(ua)) return 'android';
  return 'other';
}

export default function Download() {
  const [searchParams] = useSearchParams();
  const os = useMemo(detectOS, []);
  const target = os === 'ios' ? APP_STORE_URL : os === 'android' ? PLAY_STORE_URL : WEB_URL;

  useEffect(() => {
    // Attribution "clic" best-effort (quelle pub a amené ce visiteur) —
    // ne mesure pas les installations, seulement les clics sur le lien.
    try {
      const src = searchParams.get('src') || searchParams.get('utm_source');
      if (src && window.posthog && typeof window.posthog.capture === 'function') {
        window.posthog.capture('download_link_click', { src, os });
      }
    } catch { /* best-effort seulement */ }

    const timer = setTimeout(() => {
      window.location.replace(target);
    }, 400);
    return () => clearTimeout(timer);
  }, [target, os, searchParams]);

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 20,
        background: '#FAF7F2',
        color: '#2A1418',
        fontFamily: '-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif',
        textAlign: 'center',
        padding: 24,
      }}
    >
      <div style={{ fontWeight: 800, fontSize: 22, color: '#7A1F2B' }}>SoumissionPro</div>
      <div style={{ fontSize: 14, color: '#8A7670' }}>Redirection en cours…</div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginTop: 8, width: '100%', maxWidth: 280 }}>
        <a href={APP_STORE_URL} style={btnStyle}>Télécharger sur l'App Store</a>
        <a href={PLAY_STORE_URL} style={btnStyle}>Télécharger sur Google Play</a>
        <a href={WEB_URL} style={btnOutlineStyle}>Continuer sur le site web</a>
      </div>
    </div>
  );
}

const btnStyle = {
  display: 'block',
  padding: '12px 20px',
  borderRadius: 10,
  background: '#7A1F2B',
  color: '#fff',
  fontWeight: 700,
  fontSize: 14,
  textDecoration: 'none',
};

const btnOutlineStyle = {
  ...btnStyle,
  background: 'transparent',
  color: '#7A1F2B',
  border: '1px solid #7A1F2B',
};
